var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-area rounded-lg p-4"},[_c('h5',{staticClass:"text-uppercase"},[_vm._v("Select a product...")]),_c('base-search',{attrs:{"value":_vm.documentId,"options":_vm.productsFiltered},on:{"update:value":function($event){_vm.documentId=$event}}}),_c('p',[_vm._v("Or create a new one")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }